import DocumentItem from 'components/@home/drawers/ProfileDrawer/Profile/Mandatories/DocumentItem';
import Pagination from 'components/controls/Pagination';
import React from 'react';

const Mandatories = ({ employee, documents, total, page, perPage, changePage }) => {
  return (
    <div>
      <div>
        {documents
          .filter(d => d.attachments[0])
          .map(document => {
            const doc = { ...document.attachments, ...document };
            return (
              <DocumentItem employee={employee} key={doc._id} doc={doc}>
                {doc.title ? `${doc.title} - ${doc.attachments[0].name}` : doc.attachments[0].name}
              </DocumentItem>
            );
          })}
      </div>
      <Pagination perPage={perPage} total={total} page={page} onChange={changePage} />
    </div>
  );
};

export default Mandatories;
